import {Box, SvgIcon} from "@mui/material";
import React from "react";

export function WildCareIcon(props) {
    return(
        <img src="/Icons/wildCare.svg" alt="wildCare" {...props}/>
  )
}